// console.log('あいうえお');

// import Rellax from 'rellax';

// var rellaxElements = new Rellax('.rellax');
// console.log('rellax', rellaxElements, {

// });

import simpleParallax from 'simple-parallax-js';

const image = document.querySelectorAll('.parallax');
new simpleParallax(image, {
  scale: 1.2,
  delay: 2.0,
});
